import { MenuItem } from "@mui/material";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import { RhfOption } from "./types/RhfOption";
import { RhfProps } from "./types/RhfProps";
import { RhfStyleProps } from "./types/RhfStyleProps";
import { useTranslation } from "react-i18next";

// TODO 修正數字問題
// https://stackoverflow.com/questions/50823182/material-ui-remove-up-down-arrow-dials-from-textview
// https://stackoverflow.com/questions/58712520/force-textfield-with-type-number-to-display-dot-as-decimal-separator

type Props = RhfProps &
  RhfStyleProps &
  TextFieldProps & {
    options?: RhfOption[] | string[] | object[];
    displayMember?: string;
    valueMember?: string;
    emptyOption?: string;

    showErrorText?: boolean;
  };

const RhfTextBox = ({
  rhf,
  name,
  defaultValue,
  rules, // RhfProps
  sx,
  className,
  style, // RhfStyleProps

  options,
  children,
  displayMember,
  valueMember,
  emptyOption,

  showErrorText,

  rows,

  ...restProps // TextFieldProps
}: Props) => {
  const { t } = useTranslation();

  if (displayMember == null) {
    displayMember = "label";
  }

  if (valueMember == null) {
    valueMember = "value";
  }

  if (showErrorText == null) {
    showErrorText = true; // 預設顯示錯誤訊息
  }

  let minRows: string | number | undefined = undefined;
  let maxRows: string | number | undefined = undefined;
  let multiline: boolean | undefined = undefined;
  let fullWidth: boolean | undefined = undefined;

  if (rows != null && rows != 0) {
    minRows = rows;
    maxRows = rows;
    multiline = true;
    fullWidth = true;
  }

  return (
    <Controller
      control={rhf?.control} // 必要綁定，否則必須使用 useFormContext()
      name={name} // 必填，用來綁定 react-hook-form 對應的 value
      defaultValue={defaultValue == null ? "" : String(defaultValue)} // 如果沒指定，需要設定一個合理的初始數值，才會正常運作
      rules={rules} // react-hook-form 原生的驗證數值規則
      render={({ field, fieldState }) => {
        // 等同於: render={({ field: { onChange, onBlur, value, ref } }) => (
        const has_error = !!fieldState.error;
        return (
          <TextField
            {...restProps} // MUI 控制項的屬性
            sx={sx}
            className={className}
            style={style}
            // 以下4個目前只會因為，rows 而改變
            minRows={minRows}
            maxRows={maxRows}
            multiline={multiline}
            fullWidth={fullWidth}
            onChange={(e) => {
              field.onChange("" + e.target.value);
            }}
            onBlur={field.onBlur}
            value={field.value}
            ref={field.ref}
            // {...field} // 等同於: onChange={onChange} onBlur={onBlur} value={value} ref={ref}

            // 數值驗證錯誤提示
            error={showErrorText && has_error} // 紅色邊框
            helperText={
              showErrorText && has_error
                ? t(fieldState.error?.message ?? "")
                : undefined
            } // 錯誤訊息
          >
            {emptyOption != null ? (
              <MenuItem key={emptyOption} value={""}>
                {" "}
                {emptyOption}{" "}
              </MenuItem>
            ) : undefined}
            {options == null
              ? undefined
              : options.map((option: any) => {
                  if (typeof option === "string") {
                    option = { value: option, label: option };
                  }

                  const val = option[valueMember as string];
                  const lbl = option[displayMember as string];

                  const key = `${name}.${val}`;

                  return (
                    <MenuItem key={key} value={val}>
                      {" "}
                      {lbl}{" "}
                    </MenuItem>
                  );
                })}
            {children}
          </TextField>
        );
      }}
    />
  );
};

export default RhfTextBox;
